import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m3.047 3.863 5.26 12.772a.625.625 0 0 0 1.02.204l2.872-2.873 3.093 3.094c.245.244.64.244.884 0l.884-.884a.625.625 0 0 0 0-.884L13.966 12.2l2.873-2.873a.625.625 0 0 0-.204-1.02L3.863 3.047a.625.625 0 0 0-.816.816Z",
		fill: "#000",
		fillRule: "evenodd",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22m3.047%203.863%205.26%2012.772a.625.625%200%200%200%201.02.204l2.872-2.873%203.093%203.094c.245.244.64.244.884%200l.884-.884a.625.625%200%200%200%200-.884L13.966%2012.2l2.873-2.873a.625.625%200%200%200-.204-1.02L3.863%203.047a.625.625%200%200%200-.816.816Z%22%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23fff%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E%0A";
